import { css } from '@emotion/core'

export default {
  boldText: css`
    font-weight: bold;
  `,
  previewImage: css`
    background-color: #f6f6f6;
    padding: 10px 20px;
    border-radius: 8px;
  `,
  previewTitle: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
}
